import {AbstractControl, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';

export function isValidNodeAssignee(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const hasEmailErrors = Validators.email(control);
    const isUnassigned = 'unassigned' === String(control?.value)?.toLowerCase();

    return hasEmailErrors && !isUnassigned ? {nodeAssignee: {value: control.value}} : null;
  };
}
